import axios from "axios";
import config from "../../config/config";

const getQuizz = async (quizId, quizCulture) => {
    const request = axios.get(
        `${config.quizzWidgetAppBaseUrl}/get/${quizId}/${quizCulture}`
    );
    try {
        const response = await request;
        return {
            title: response.data.title,
            quizz: response.data.questions,
            nextButtonText: response.data.nextBtnText,
            previousBtnText: response.data.previousBtnText,
            backToQuizzBtnText: response.data.backToQuizzBtnText,
            seeResultsBtnText: response.data.seeResultsBtnText

        };
    } catch (error) {
        throw new Error(error);
    }
};

const postQuizz = async (quizId, quizCulture, quizData) => {
    const request = axios.post(`${config.quizzWidgetAppBaseUrl}/result/${quizId}/${quizCulture}`, quizData, {
        headers: {
            //"content-type": "multipart/form-data",
            "content-type": "application/json"
        },
    });
    try {
        const response = await request;
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
};

export { getQuizz, postQuizz };
